import { useForm } from '@givebacks/formy';
import { default as ReCAPTCHA } from 'react-google-recaptcha';
import { Alert, Center, Stack } from 'ui';
import { isNotEmpty } from 'ui/Form';

import { ReCAPTCHAForm } from '../checkout.types';

const CheckoutReCAPTCHA = () => {
  const form = useForm<ReCAPTCHAForm>(
    {
      initialValues: {
        recaptcha: '',
      },
      validate: {
        recaptcha: isNotEmpty('ReCAPTCHA is required'),
      },
    },
    {
      id: 'recaptcha',
    }
  );

  return (
    <>
      <Alert.Collapse title="ReCAPTCHA is required" type="error" in={!!form.errors.recaptcha} />
      <Stack>
        <Center style={{ isolation: 'isolate' }}>
          <ReCAPTCHA
            sitekey={import.meta.env.VITE_RECAPTCHA_KEY}
            onChange={(key) => form.setFieldValue('recaptcha', key)}
          />
        </Center>
      </Stack>
    </>
  );
};

const WrappedCheckoutReCAPTCHA = () => {
  // Don't show if there is no recaptcha key or if the environment is not production
  if (!import.meta.env.VITE_RECAPTCHA_KEY || import.meta.env.VITE_API_ENV != 'production') {
    return null;
  }

  return <CheckoutReCAPTCHA />;
};

export { WrappedCheckoutReCAPTCHA as CheckoutReCAPTCHA };
